import { graphql } from 'gatsby';
import * as React from 'react';
import ContactForm from '../components/ContactForm';
import Layout from '../components/Layout';

const ContactPage = (props: any) => {
	return <Layout
				pageTitle={'Contact Us'}
				metaDescription={'Contact MK Decisioning Systems, Inc: call us or fill out the contact form'}
				splashHeaderMinHeight={'none'}
				skipNavC2A={false}
				BodyClass={'contact'}
			>
		<div className='centeredWrapper'>
			<ContactForm endpoint={props.data.site.siteMetadata.endpoint} />
		</div>
	</Layout>;
};

export const query = graphql`
	query ContactPage {
		site: site {
			siteMetadata {
				endpoint
			}
		}
	}
`;

export default ContactPage;
